"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextAreaBase = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _propTypes = require("../prop-types");

var _styles = require("../styles");

var _utils = require("../utils");

var _core = require("@emotion/core");

var _excluded = ["disabled", "error", "theme", "warning"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TextAreaBase = (0, _context.styledWithTheme)('textarea')(function (_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      theme = _ref.theme,
      warning = _ref.warning,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var selectors = theme.selectors;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _styles.inputStyles)({
    error: error,
    props: props,
    selectors: selectors,
    warning: warning
  })), (0, _styles.disabledStyles)({
    error: error,
    disabled: disabled,
    selectors: selectors,
    warning: warning
  })), (0, _utils.getPropsStyles)(['flex', 'justifyContent', 'alignItems', 'flexDirection', 'flexWrap', 'alignSelf'], props)), (0, _utils.getSpacingStyles)(['width', 'height', 'minWidth', 'maxWidth', 'minHeight', 'maxHeight', 'margin', 'padding'], props, selectors.space)), (0, _styles.disabledIconStyles)({
    disabled: disabled,
    theme: theme
  })), {}, {
    display: props.display,
    resize: props.resize
  });
});
exports.TextAreaBase = TextAreaBase;
TextAreaBase.defaultProps = {
  resize: 'none',
  display: 'block'
};

var TextAreaWithoutDocs = /*#__PURE__*/_react.default.forwardRef(function (forwardedProps, ref) {
  return (0, _core.jsx)(TextAreaBase, (0, _extends2.default)({}, forwardedProps, {
    ref: ref
  }));
});

var TextAreaBaseWithDocs = (0, _stencilReactDesc.describe)(TextAreaWithoutDocs).description('Form component that accepts long text inputs.');
TextAreaBaseWithDocs.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _propTypes.formElementPropTypes), _propTypes.flexAttributesPropTypes), _propTypes.widthWithMinMaxPropTypes), _propTypes.heightWithMinMaxPropTypes), {}, {
  resize: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'resize' property for the element."),
  placeholder: _stencilReactDesc.PropTypes.string.description('Displays placeholder text in the text area until the user begins typing.')
});
var TextArea = (0, _utils.withTestAttributes)({
  component: 'StencilReactTextArea'
})(TextAreaBaseWithDocs);
TextArea.displayName = 'TextArea';
var _default = TextArea;
exports.default = _default;